import React from "react";
import { Skeleton, Divider, Row, Col } from "antd";

const TeacherDetailSkeleton = () => {
  return (
    <div className="teacher-details-container">
      {/* Academic Experience */}
      <div className="detail-section" style={{ padding: "12px 0" }}>
        <Row gutter={16}>
          <Col span={6}>
            <Skeleton.Button active size="small" style={{ width: 100 }} />
          </Col>
          <Col span={18}>
            <Skeleton active title={false} paragraph={{ rows: 2 }} />
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: "12px 0" }} />

      {/* Corporate Experience */}
      <div className="detail-section" style={{ padding: "12px 0" }}>
        <Row gutter={16}>
          <Col span={6}>
            <Skeleton.Button active size="small" style={{ width: 100 }} />
          </Col>
          <Col span={18}>
            <Skeleton active title={false} paragraph={{ rows: 2 }} />
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: "12px 0" }} />

      {/* Courses */}
      <div className="detail-section" style={{ padding: "12px 0" }}>
        <Row gutter={16}>
          <Col span={6}>
            <Skeleton.Button active size="small" style={{ width: 100 }} />
          </Col>
          <Col span={18}>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <Skeleton.Button active size="small" style={{ width: 80 }} />
              <Skeleton.Button active size="small" style={{ width: 60 }} />
              <Skeleton.Button active size="small" style={{ width: 90 }} />
            </div>
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: "12px 0" }} />

      {/* Boards */}
      <div className="detail-section" style={{ padding: "12px 0" }}>
        <Row gutter={16}>
          <Col span={6}>
            <Skeleton.Button active size="small" style={{ width: 100 }} />
          </Col>
          <Col span={18}>
            <Skeleton active title={false} paragraph={{ rows: 1 }} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TeacherDetailSkeleton;
